import React from 'react';

import Pic1 from '../../InstallImages/Inverters/Fronius';


const froniusLink1 = <a href="https://www.fronius.com/en-us/usa/photovoltaics/who-we-are/history" rel="noopener noreferrer" target="_blank">History</a>;
const froniusLink2 = <a href="https://www.fronius.com/en-us/usa/photovoltaics/who-we-are/philosophy" rel="noopener noreferrer" target="_blank">Philosophy</a>;
const froniusLink3 = <a href="https://www.fronius.com/en-us/usa/photovoltaics/who-we-are/philosophy/innovation" rel="noopener noreferrer" target="_blank">Innovation</a>;

const Inverter = () => (
    <div>
        <div className="col span-1-of-2">

            <Pic1 />
        </div>
        <div className="col span-1-of-2">
            <h1>YOU CAN COUNT ON RELIABILITY IN THE PHOTOVOLTAICS INDUSTRY</h1>
            <p className="specsText">Long-term and visionary thinking, decades of experience, intensive research and constant innovations make us the global quality and technology leader in the solar technology industry. The family company based in Pettenbach, Upper Austria, has developed into a successful international group with 28 subsidiaries globally.
            </p>
            <p className="specsText">Fronius USA is the biggest subsidiary with over 100 staff, 400,000-square-foot building housing domestic manufacturing and technical support. We have representatives nationwide and R&D and Solution Management offices in the San Francisco Bay Area. Our team in the United States yield collective years of industry experience and a dedication to excellent customer service unmatched by competitors. Our partnerships with our Welding and Battery Charging divisions forge additional strength and stability to the brand, and offer the opportunity to create synergies. We do not focus on quarterly figures, but on sustainable and healthy growth, outstanding quality and the responsible use of resources. With these high standards we offer our customers an extensive range of products and services, and are a secure and reliable partner to many companies.
            </p>
            <ul>
                <li className="specsText">{froniusLink1}</li>
                <li className="specsText">{froniusLink2}</li>
                <li className="specsText">{froniusLink3}</li>
            </ul>
        </div>
    </div>
);


export default Inverter;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/SystemSpecs/Inverters/fronius.js